if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        /* ---------------------------
           Cart total (cents → currency)
        ---------------------------- */
        const rawTotal = parseInt(this.getAttribute('data-cart-total'), 10) || 0;
        const total = rawTotal / 100;

        const bar = this.querySelector('.free-shipping--percentage');
        const messageEl = this.querySelector('.free-shipping--message');
        const stepsContainer = this.querySelector('.free-shipping--steps');

        /* ---------------------------
           Read steps SAFELY
        ---------------------------- */
        const steps = [];

        for (let i = 1; i <= 3; i++) {
          const enabled =
            String(this.getAttribute(`data-step-${i}-enabled`))
              .trim()
              .toLowerCase() === 'true';

          const amount = parseFloat(this.getAttribute(`data-step-${i}`));
          const label = this.getAttribute(`data-label-${i}`);

          console.log(`Step ${i}`, { enabled, amount, label });

          if (enabled && !isNaN(amount)) {
          steps.push({
            amount,
            label,
            lockedMessage: this.getAttribute(`data-step-${i}-locked-message`) || '',
            unlockedMessage: this.getAttribute(`data-step-${i}-unlocked-message`) || ''
          });
        }

        }

        console.log('FINAL steps array:', steps);

        if (!steps.length) return;

        /* ---------------------------
           Progress calculation
        ---------------------------- */
        steps.sort((a, b) => a.amount - b.amount);

          // Add extra 10% padding to max value
          const paddingFactor = 1.1; // 10% more
          const rawMax = steps[steps.length - 1].amount;
          const paddedMax = rawMax * paddingFactor;

          const percentage = Math.min(total / paddedMax, 1);


        if (bar) {
          bar.style.setProperty('--percentage', percentage);
        }

        /* ---------------------------
           Message text
        ---------------------------- */
      if (messageEl) {
        const format =
          window.theme?.settings?.money_with_currency_format || '${{amount}}';

        // Steps user has NOT yet reached
        const lockedSteps = steps.filter(step => total < step.amount);

        if (lockedSteps.length) {
          // Next upcoming step
          const nextStep = lockedSteps[0];
          const remaining = nextStep.amount - total;

          messageEl.innerHTML = (nextStep.lockedMessage || '')
            .replace('{{ amount }}', formatMoney(remaining * 100, format));
        } else {
          // All steps unlocked → show highest unlocked message
          const lastStep = steps[steps.length - 1];
          messageEl.innerHTML = lastStep.unlockedMessage || '';
        }
      }




        /* ---------------------------
           Step labels
        ---------------------------- */
        if (stepsContainer) {
        stepsContainer.innerHTML = '';

        steps.forEach(step => {
        const el = document.createElement('span');
        el.className = 'free-shipping--step';
        el.innerHTML = `
          <span class="free-shipping--dot"></span>
          <span class="free-shipping--label">${step.label}</span>
        `;

        // position relative to padded max
        const position = Math.min(step.amount / paddedMax, 1) * 100;
        el.style.left = position + '%';

        if (total >= step.amount) el.classList.add('is-active');
        stepsContainer.appendChild(el);
      });
      }
      });
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
